import React from 'react';
import SurfaceCard from './SurfaceCard';
import {BoxProps, Heading, Text, VStack} from 'components/ui/chakra';

interface EmptyStateProps extends BoxProps {
	actions?: React.ReactNode;
	description: React.ReactNode;
	heading: React.ReactNode;
}

const EmptyState = ({actions, description, heading, ...rest}: EmptyStateProps) => (
	<SurfaceCard muted p={{base: 6, md: 8}} textAlign='center' {...rest}>
		<VStack gap={3}>
			<Heading as='div' fontSize={{base: 'xl', md: '2xl'}}>
				{heading}
			</Heading>
			<Text color='subtleText' maxW='xl'>
				{description}
			</Text>
			{actions}
		</VStack>
	</SurfaceCard>
);

export default EmptyState;
